import { Tooltip } from 'antd'
import classNames from 'classnames'
import { Fragment } from 'react'

import {
  EMPTY_SLOT_PLACEHOLDER,
  groupSlottedValuesForDisplay,
} from '@/utils/search/characteristics/slottedCharacteristics'

import { IRRELEVANT_VALUE_TOOLTIP } from '../../Filters.utils'
import cn from './FilterChipValues.module.scss'

interface ChipValueProps {
  label: string
  isIrrelevant: boolean
}

function ChipValue({ label, isIrrelevant }: ChipValueProps) {
  if (!isIrrelevant) return <span className={cn.value}>{label}</span>

  return (
    <Tooltip title={IRRELEVANT_VALUE_TOOLTIP}>
      <span className={classNames(cn.value, cn.valueIrrelevant)}>{label}</span>
    </Tooltip>
  )
}

interface FilterChipValuesProps {
  values: string[]
  irrelevantValues: string[]
  isSlotted: boolean
  formatValue: (value: string) => string
}

function FilterChipValues({
  values,
  irrelevantValues,
  isSlotted,
  formatValue,
}: FilterChipValuesProps) {
  const irrelevant = new Set(irrelevantValues)

  if (!isSlotted) {
    return (
      <span className={cn.values}>
        {values.map((value) => (
          <ChipValue
            key={value}
            label={formatValue(value)}
            isIrrelevant={irrelevant.has(value)}
          />
        ))}
      </span>
    )
  }

  return (
    <span className={cn.values}>
      {groupSlottedValuesForDisplay(values).map((slotValues, slotIndex) => (
        <Fragment key={`slot-${slotIndex + 1}`}>
          {slotIndex > 0 && <span className={cn.separator}>×</span>}
          {slotValues.length === 0 ? (
            <span className={cn.separator}>{EMPTY_SLOT_PLACEHOLDER}</span>
          ) : (
            slotValues.map((value) => (
              <ChipValue
                key={value.raw}
                label={value.label}
                isIrrelevant={irrelevant.has(value.raw)}
              />
            ))
          )}
        </Fragment>
      ))}
    </span>
  )
}

export default FilterChipValues
